export default "__VITE_ASSET__ae8ad662__"